<template>
  <div class="overlay" v-show="this.view">
    <div class="overlayInnerWrap">
      <div class="categoriesWrap">
        <ul class="cateogories">
          <li
            v-if="categories != null && categories.length > 0"
            v-for="(category , index) in portfolio.categories">
            <div class="category">
              {{ categories.find(n=>n.num === category).name }}
            </div>
          </li>
        </ul>
      </div>

      <div class="companyName">
        {{ portfolio.title }}
      </div>

      <div class="period">
        {{ portfolio.startDate }} ~ {{ portfolio.endDate }}
      </div>

      <div class="contentButtonWrap">
        <button type="button" class="fullScreen"
        @click="portfolioOpen(portfolio)"
        ></button>
        <button type="button"
                class="site"
                @click="siteGo(portfolio.siteUrl)"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import PortfolioItemModal from "./PortfolioItemModal";

  export default {
    name: "portfolio-overlay",
    components: {},
    props: ['portfolio'],
    computed: {
      ...mapState('categoryStore' , ['categories']),
      /*realView () {
        get : function () {
        },
        set : function () {
        },
      }*/
    },
    watch: {

    },
    methods: {
      portfolioOpen ( portfolio ) {
        //const item = this.issueItemList.find( (n) => n.num === num);



        const clientWidth = document.body.clientWidth;
        const clientHeight = document.body.clientHeight;


        this.$modal.show(PortfolioItemModal , {
          portfolio: portfolio ,
        }, {
          resizable : true ,
          draggable: false ,
          width : clientWidth * (clientWidth <= 767 ? 0.8 : 0.4),
          height : clientHeight * 0.8 ,
        } , {
          'before-close' : (event) => {
            if(this.view && !this.mobile)
              this.view = !this.view;

            if(this.modalState)
              this.modalState = !this.modalState;

          },
          'closed' : (event) => {
            /*if(this.view)
              this.view = !this.view;*/
            //console.log('closed!!')
          },
        })

        this.modalState = true;

        /*if(this.view)
          this.view = false;*/
      },
      siteGo (siteUrl) {
        window.open(
          siteUrl,
          '_blank' // <- This is what makes it open in a new window.
        );
      }
    },
    data() {
      return {
        view : false ,
        modalState : false,
        mobile : false ,
      }
    },
    created() {
      const clientWidth = document.body.clientWidth;
      const clientHeight = document.body.clientHeight;
      if(clientWidth <= 999) {
        this.mobile = true;
        this.view = true;
      }
    },
    updated() {

    },
    mounted() {

    },


  }
</script>

<style scoped lang="scss">
  @import '@/styles/Global.scss';
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(26 , 45 , 57 , 0.7);
    @include respond-to('medium') {
      display: block;
    }
    .overlayInnerWrap{
      width:80%;
      height:100%;
      margin:0 auto;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      .categoriesWrap{
        //margin-top:-1rem;
        >ul.cateogories{
          display: flex;
          flex-flow: row nowrap;
          list-style: none;
          color:#fff;
          justify-content: center;
          >li{
            margin-right:0.7rem;
            &:last-child{
              margin-right:0;
            }
          }
          .category{
            font-size:1.5rem;
            border-top:2px solid #fff;
            @include respond-to('medium') {
              font-size:1rem;
            }
          }
        }
      }
      .companyName{
        color:#fff;
        font-size:2.3rem;
        @include respond-to('medium') {
          font-size:1.5rem;
        }
      }
      .period{
        color:#fff;
        font-size:1.15rem;
        font-weight: 200;
      }

      .contentButtonWrap{
        margin-top:1rem;
        width:30%;
        display: flex;
        justify-content: space-between;
        >button{
          background-color: transparent;
          border:0;
          width:30px;
          height:30px;
          cursor: pointer;
          &:focus{
            outline: 0;
          }

          &.fullScreen {
            background: url(//d77k7si2heyyr.cloudfront.net/images/icons/full-screen.png) center no-repeat;
          }
          &.site {
            background: url(//d77k7si2heyyr.cloudfront.net/images/icons/display.png) center no-repeat;
          }
        }
      }
    }


  }

  //https://d77k7si2heyyr.cloudfront.net/images/icons/display.png
  //https://d77k7si2heyyr.cloudfront.net/images/icons/full-screen.png
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/PortfolioOverlay.vue